module.exports = __webpack_public_path__ + "img/search.6b3d219b.svg";